import {api} from "@/api/axios";

export function getClickIdAccess(params = {}) {
    return api.get(`/affiliate-stats/click-id-reportsaccess`, {params})
}

export function getClickIdFilters(params = {}) {
    return api.get(`/affiliate-stats/click-id-reports/filters`, {params})
}

export function getClickIdExportList(params = {}) {
    return api.get(`/affiliate-stats/click-id-reports`, {params})
}

export function requestClickIdExport(params = {}) {
    return api.post(`/affiliate-stats/click-id-reports`, params)
}

export function downloadClickIdExport(uuid) {
    return api.get(`/affiliate-stats/click-id-reports/${uuid}/download`)
}

export function deleteClickIdExport(uuid) {
    return api.delete(`/affiliate-stats/click-id-reports/${uuid}`)
}